import type { Sx } from '@evrone-erp/uikit';
import { BaseIcon, BaseLink, mergeSx } from '@evrone-erp/uikit';
import { Box, Typography } from '@mui/material';
import React from 'react';
interface IPageHeaderProps {
  children?: string;
  typographyVariant?: Parameters<typeof Typography>[0]['variant'];
  backHref?: string;
  sx?: Sx;
}
export const PageTitle = ({
  backHref,
  children,
  typographyVariant = 'subtitle',
  sx
}: IPageHeaderProps) => <Box sx={mergeSx({
  display: 'flex',
  alignItems: 'center',
  gap: '20px'
}, sx)}>
    {backHref && <BaseLink href={backHref} noSign>
        <BaseIcon type="arrow-left" />
      </BaseLink>}

    {children && <Box>
        <Typography variant={typographyVariant}>{children}</Typography>
      </Box>}
  </Box>;